import { querySelectorAllDeep } from 'query-selector-shadow-dom';
import { DebugService } from './debug.service.js';

class _FormValidationService {
  constructor() {
    this.debug = new DebugService('FormValidationService');
  }

  async validateAllFields(form, blur = true) {
    this.debug.log('validateAllFields called with', form);
    const inputs = querySelectorAllDeep('input, select, textarea', form);
    let firstInvalid = null;
    let focused = false;
    await inputs.forEach(async input => {
      const valid = await input.checkValidity();
      if (!valid) {
        if (firstInvalid === null) {
          firstInvalid = input;
        }
        if (blur) {
          input.focus();
        }
        focused = true;
      }
    });
    if (firstInvalid != null && blur) {
      firstInvalid.blur();
      firstInvalid.focus();
    }
    return !focused;
  }
}

export const FormValidationService = new _FormValidationService();
